import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { observable, action, computed } from 'mobx';
import { task } from 'mobx-task';
import { func, validationContext } from 'validx';
var PromptDialogStore = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _dec6 = task.resolved, _dec7 = task.resolved, _class = /*#__PURE__*/function (_Store) {
  function PromptDialogStore() {
    var _this;
    _classCallCheck(this, PromptDialogStore);
    _this = _callSuper(this, PromptDialogStore, arguments);
    _initializerDefineProperty(_this, "showing", _descriptor, _this);
    _initializerDefineProperty(_this, "showingDeleteDialog", _descriptor2, _this);
    _initializerDefineProperty(_this, "answer", _descriptor3, _this);
    _initializerDefineProperty(_this, "prompt", _descriptor4, _this);
    _initializerDefineProperty(_this, "job", _descriptor5, _this);
    _initializerDefineProperty(_this, "workInProgress", _descriptor6, _this);
    _this.validation = validationContext();
    _this.MAX_TEXT_LENGTH = 280;
    _this.rules = {
      answer: [func(function (a) {
        return a !== null;
      }, 'An answer is required'), func(function (a) {
        var _this$prompt, _this$prompt$question, _a$value;
        return ((_this$prompt = _this.prompt) === null || _this$prompt === void 0 ? void 0 : (_this$prompt$question = _this$prompt.question) === null || _this$prompt$question === void 0 ? void 0 : _this$prompt$question.type) === 'TEXT' ? ((_a$value = a.value) === null || _a$value === void 0 ? void 0 : _a$value.length) <= _this.MAX_TEXT_LENGTH : true;
      }, "Your answer must be less than ".concat(_this.MAX_TEXT_LENGTH, " characters"))]
    };
    _this.save = _this.save.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }
  _inherits(PromptDialogStore, _Store);
  return _createClass(PromptDialogStore, [{
    key: "show",
    value: function show(prompt) {
      var _this$workInProgress$;
      this.validation.reset();
      this.answer = (_this$workInProgress$ = this.workInProgress[prompt.id]) !== null && _this$workInProgress$ !== void 0 ? _this$workInProgress$ : null;
      this.prompt = prompt;
      this.showing = true;
    }
  }, {
    key: "showDeleteDialog",
    value: function showDeleteDialog() {
      this.showingDeleteDialog = true;
    }
  }, {
    key: "hideDeleteDialog",
    value: function hideDeleteDialog() {
      this.showingDeleteDialog = false;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.showing = false;
    }
  }, {
    key: "setAnswer",
    value: function setAnswer(answer) {
      this.validation.reset();
      this.answer = answer;
      this.workInProgress[this.prompt.id] = answer;
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.validation.reset().validate(this, this.rules).isValid) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return this.rootStore.promptStore.answerPrompt({
                id: this.prompt.id,
                type: this.prompt.question.type,
                answer: this.answer
              });
            case 4:
              this.hide();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.prompt.canDelete) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return this.rootStore.promptStore.deletePrompt({
                id: this.prompt.id
              });
            case 4:
              this.hideDeleteDialog();
              this.hide();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _delete() {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }, {
    key: "canAnswer",
    get: function get() {
      return this.prompt.canAnswer;
    }
  }, {
    key: "canDelete",
    get: function get() {
      return this.prompt.canDelete;
    }
  }, {
    key: "canSubmit",
    get: function get() {
      if (this.prompt.question.type === 'DOCUMENTS') {
        var _this$answer;
        return ((_this$answer = this.answer) === null || _this$answer === void 0 ? void 0 : _this$answer.length) >= 1;
      }
      return this.answer !== null;
    }
  }, {
    key: "currentWorkInProgress",
    get: function get() {
      return this.workInProgress[this.prompt.id];
    }
  }, {
    key: "completedDescription",
    get: function get() {
      var _this$prompt$answered;
      if (!this.prompt.dateAnswered) {
        return '';
      }
      var day = new Intl.DateTimeFormat('en-US', {
        dateStyle: 'short'
      }).format(this.prompt.dateAnswered);
      var time = new Intl.DateTimeFormat('en-US', {
        timeStyle: 'short'
      }).format(this.prompt.dateAnswered);
      return this.prompt.answeredBy ? "Completed by ".concat((_this$prompt$answered = this.prompt.answeredBy) === null || _this$prompt$answered === void 0 ? void 0 : _this$prompt$answered.displayName, " on ").concat(day, " at ").concat(time) : "Completed on ".concat(day, " at ").concat(time);
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showingDeleteDialog", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "answer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "prompt", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "job", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "workInProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "show", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeleteDialog", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "showDeleteDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDeleteDialog", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "hideDeleteDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hide", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "hide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAnswer", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "setAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "delete", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "delete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canAnswer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canDelete", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canDelete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canSubmit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentWorkInProgress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentWorkInProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completedDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "completedDescription"), _class.prototype), _class);
export { PromptDialogStore as default };
//# sourceMappingURL=PromptDialogStore.js.map
